import React, { useState, useMemo, useEffect } from 'react';
import s from './s.module.less';
import { IKlaritySpecialtyForm } from 'types/serviceTemplate';
import cx from 'classnames';
import { EKlarityPage, TServiceSetting } from 'types/helloKlarity';

const ServicePreview = ({
    previewList,
    type,
}: {
    previewList: IKlaritySpecialtyForm[];
    type?: EKlarityPage
}) => {
    const previewData = useMemo(() => {
        return previewList.slice(0, 4);
    }, [previewList]);
    const [selectedSpecialtyId, setSelectedSpecialtyId] = useState<number>();
    const selectedSpecialty = useMemo(() => previewData?.find((spec) => spec.id === selectedSpecialtyId), [previewData, selectedSpecialtyId]);
    const services = useMemo(() => selectedSpecialty?.services || [], [selectedSpecialty]);

    useEffect(() => {
        setSelectedSpecialtyId(previewData?.[0]?.id);
    }, [previewData]);

    return (
        <div className={s.previewPc}>
            <div className={s.wrapIn}>
                {
                    type === EKlarityPage.MED_HOME && (
                        <>
                            <div className={s.wrapHeader}>
                                <h2 className={s.title}>Get a prescription for your treatment</h2>
                                <a className={s.link} href="#">View all services <span className={s.linkIcon}>→</span></a>
                            </div>
                            <div className={s.wrapDes}>Klarity providers can assess whether a medication is right for you and prescribe it if appropriate.</div>
                        </>
                    )
                }
                {
                    type !== EKlarityPage.MED_HOME && (
                        <div className={s.wrapHeader}>
                            <h2 className={s.title}>All services Klarity providers can help with</h2>
                            <a className={s.link} href="#">View all services <span className={s.linkIcon}>→</span></a>
                        </div>
                    )
                }

                <div className={s.specialties}>
                    {previewData?.map((specialty) => (
                        <div
                            key={specialty.id}
                            className={cx(s.specialtyTab, { [s.active]: specialty.id === selectedSpecialtyId })}
                            onClick={() => setSelectedSpecialtyId(specialty.id)}
                        >
                            {specialty.specialtyName}
                        </div>
                    ))}
                </div>
                <div className={s.serviceList}>
                    {services.map((item: TServiceSetting, idx: number) => (
                        <div className={`${s.serviceItem} ${type === EKlarityPage.MED_HOME ? s.medHomeServiceItem : ''}`} key={idx}>
                            <div className={s.serviceImgWrap}>
                                <img src={item.image} alt={item.title} className={s.serviceImg} />
                            </div>
                            <div className={s.serviceTitle}>{item.title}</div>
                            <div className={s.serviceSubtext}>{item.subtext}</div>
                        </div>
                    ))}
                </div>
            </div>
        </div>
    );
};

export default ServicePreview;
